import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";
export const SquareIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Square</title>
    <polygon points="44 4 4 4 4 44 44 44"></polygon>
  </IconBase>
);
